import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useSelectedTeam = () => {
  const { teamId, user } = useSelector(({ teams, auth }) => ({
    teamId: teams.teamId,
    user: auth.user,
  }));

  const team = useMemo(() => {
    // Get team from user.role (basic info)
    // Convert both to strings for comparison to handle type mismatches
    const basicTeam = user?.role?.find((role) => String(role.teamId) === String(teamId)) ?? {};
    return basicTeam;
  }, [teamId, user]);
  
  return {
    teamId,
    team,
    ...team // Spread team properties for backward compatibility
  };
};

export const useSelectedCompany = () => {
  const { user } = useSelector(({ auth }) => ({
    user: auth.user
  }));
  const company = useMemo(() => {
    return user.company
  }, [user]);
  return company;
}

export const useTeamListRedux =()=>{
  const {teams} = useSelector(({auth})=>({
    teams:auth.user.role.map(({teamId,teamName})=>({teamId,teamName}))
  }))

  return teams
}